import { NotificationConstants } from "../constants";

export const notification = (state = { notificationLoader: false }, action) => {
  switch (action.type) {
    case NotificationConstants.GETNOTIFICATION_REQUEST:
      return {
        ...state,
        notificationLoader: true,
      };
    case NotificationConstants.GETNOTIFICATION_SUCCESS:
      return {
        ...state,
        notificationData: action.notification,
        notificationLoader: false,
      };
    case NotificationConstants.GETNOTIFICATION_FAILURE:
      return {
        error: action.error,
        notificationLoader: false,
      };
    case NotificationConstants.GETUNREAD_NOTIFICATION_REQUEST:
      return {
        ...state,
      };
    case NotificationConstants.GETUNREAD_NOTIFICATION_SUCCESS:
      return {
        ...state,
        unreadNotification: action?.unreadnotification?.count,
      };
    case NotificationConstants.GETUNREAD_NOTIFICATION_FAILURE:
      return {
        error: action.error,
      };
    case NotificationConstants.READ_NOTIFICATION_REQUEST:
      return {
        ...state,
      };
    case NotificationConstants.READ_NOTIFICATION_SUCCESS:
      return {
        ...state,
        unreadNotification: 0,
      };
    case NotificationConstants.READ_NOTIFICATION_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
};
